import { makeStyles } from "@material-ui/core/styles";

const useManageDowngradeModalStyles = makeStyles(() => ({
  modalWrapper: {
    width: "800px",
    backgroundColor: "#1B1D28",
    boxShadow: "0px 19px 45px rgba(0, 0, 0, 0.12)",
    borderRadius: "20px",
    padding: "24px 24px 48px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    color: "#F9F9F9",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "16px",
  },

  title: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "36px",
  },

  body: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },

  description: {
    fontFamily: "Poppins",
    fontSize: "13px",
    lineHeight: "20px",
    color: "#F9F9F9",
  },

  tableWrapper: {
    display: "flex",
    flexDirection: "column",
  },

  tableHeader: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "8px",
    borderBottom: "1px solid #6C65D9",
    fontSize: "14px",
    color: "#B1B5C9",
  },

  row: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: "1px solid #606479",
    fontSize: "14px",
  },

  colLabel: {
    width: "150px",
    color: "#B1B5C9",
  },

  colCurrent: {
    width: "200px",
    color: "#F9F9F9",
  },

  colNew: {
    width: "200px",
    color: "#F9F9F9",
  },

  colNewError: {
    width: "200px",
    color: "#FF4444",
  },
}));

export default useManageDowngradeModalStyles;
